import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroSection from "./components/HeroSection";
import EntryBar from "./components/EntryBar";
import FeatureFlow from "./components/FeatureFlow";
import TimelineSection from "./components/TimelineSection";
import EvidenceSection from "./components/EvidenceSection";
import InsiderSection from "./components/InsiderSection";
import InsightsSection from "./components/InsightsSection";
import SubmitSection from "./components/SubmitSection";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <HeroSection />
        <EntryBar />
        <FeatureFlow />
        <TimelineSection />
        <EvidenceSection />
        <InsiderSection />
        <InsightsSection />
        <SubmitSection />
      </main>
      <SiteFooter />
    </div>
  );
}